import CrudTable, { TextField, TextArea, JsonField, SelectField } from './CrudTable';

const CATEGORIES = ['Design', 'Engineering', 'Brand', 'Growth'];
const ICONS = ['Sparkles', 'Code2', 'Palette', 'TrendingUp', 'Smartphone', 'ShoppingBag'];

export default function AdminServices() {
  return (
    <CrudTable
      table="services"
      title="Services"
      itemLabel="service"
      publicPath={it => it.slug ? `/services/${it.slug}` : null}
      defaults={{ slug: '', title: '', tagline: '', icon: 'Sparkles', category: 'Design', short: '', features: [], price_from: 0, order_index: 0, meta_title: '', meta_description: '' }}
      columns={[
        { key: 'title', label: 'Title' },
        { key: 'category', label: 'Category', className: 'col-span-2' },
        { key: 'slug', label: 'Slug', className: 'col-span-2' },
        { key: 'price_from', label: 'From', className: 'col-span-2', format: v => v ? `$${v}` : '—' },
      ]}
      render={(it, set) => (
        <>
          <TextField label="Title" value={it.title} onChange={v => set({ ...it, title: v })} required />
          <TextField label="Slug" value={it.slug} onChange={v => set({ ...it, slug: v })} required />
          <TextField label="Tagline" value={it.tagline} onChange={v => set({ ...it, tagline: v })} />
          <SelectField label="Category" value={it.category} options={CATEGORIES} onChange={v => set({ ...it, category: v })} />
          <SelectField label="Icon (lucide name)" value={it.icon} options={ICONS} onChange={v => set({ ...it, icon: v })} />
          <TextArea label="Short description" value={it.short} onChange={v => set({ ...it, short: v })} />
          <JsonField label="Features" value={it.features} onChange={v => set({ ...it, features: v })} />
          <TextField label="Price from ($)" type="number" value={it.price_from} onChange={v => set({ ...it, price_from: v })} />
          <TextField label="Order" type="number" value={it.order_index} onChange={v => set({ ...it, order_index: v })} />
          <div className="border-t border-ink-100 pt-4">
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-ink-400">SEO (optional — falls back to title/tagline if left blank)</p>
          </div>
          <TextField label="Meta title" value={it.meta_title} onChange={v => set({ ...it, meta_title: v })} />
          <TextArea label="Meta description" value={it.meta_description} onChange={v => set({ ...it, meta_description: v })} rows={2} />
        </>
      )}
    />
  );
}
